import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Tabs
import BasesEditTab from './Elements/BasesEditTab';
import getLocale from '../../i18n/getLocale';

class BasesEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
      base_dates: {},
      base_data: {},
      staff_list: {},
      sigmec_bases: {},
      bases_rubi: {},
      cost_centers: [],
      cost_centers_select: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.loadData = this.loadData.bind(this);
  }

  // Handlers
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/base/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/bases');
        if (responseJson.status === 'success') {
          self.setState({base_data: responseJson.data.main});
          self.setState({sigmec_bases: responseJson.data.sigmec_bases});
          self.setState({bases_rubi: responseJson.data.bases_rubi});
          self.setState({base_dates: responseJson.data.base_dates});
          self.setState({cost_centers: responseJson.data.cost_centers});
          self.setState({base_companies: responseJson.data.base_companies});
          self.setState({companies_select: responseJson.data.companies_select});
        }
      }).then(() => {
      var url = config.get('api') + '/funcionarios/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({staff_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/centros-de-custo/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({cost_centers_select: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */ }); /* Lista centro de custos */ }); /* Lista tripulantes */
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Bases.EditarBase.titulo}</h3>
      <Link to="/bases" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <BasesEditTab handleAlert={this.handleAlert} base_id={this.props.match.params.id} staff_list={this.state.staff_list} base_data={this.state.base_data} sigmec_bases={this.state.sigmec_bases} bases_rubi={this.state.bases_rubi} base_dates={this.state.base_dates} cost_centers_select={this.state.cost_centers_select} companies_select={this.state.companies_select} base_companies={this.state.base_companies} cost_centers={this.state.cost_centers}/>
    </div>
  </div>
</div>
    );
  }
}

export default BasesEdit;



// WEBPACK FOOTER //
// ./src/Components/Bases/BasesEdit.js